import store from '@/vuex/store'

const subscribeCanvasBlockPluginLegacy = (_store) => {
  _store.subscribeAction((action) => {
    if (action.type === 'kvSync/updateKeyValueAction') {
      const { key, value } = action.payload
      if (key.indexOf('/canvasBlocksUrl') !== -1) {
        const arr = key.split('/')
        store.dispatch('updateSlideCanvasBlockByIdAction', { canvasBlocksUrl: value, id: Number(arr[2]) })
      }
    }
  })
}

export default subscribeCanvasBlockPluginLegacy
